import { Grid, Box } from '@mui/material'
import { Typography } from '@nwh-consumer-digital/nw-component-lib'

const adultPageFourSuccess = (props) => {
  return (
    <Box className="pageContainer">
      <Grid container direction="column" justifyContent="space-between" alignItems="left">
        <Grid item xs={12}>
          <img src="/images/Check.png" className="imgAlign"></img>
          <Typography variant="h1" style={{ marginTop: 80, marginBottom: 16 }} className="imgAlign noPad">
            ¡Éxito!
          </Typography>
        </Grid>
        <Grid item xs={12} s={12} md={12}>
          <Typography variant="body" size="large" weight="plain" style={{ fontSize: 18 }}>
            Por favor, espere una invitación con instrucciones sobre cómo crear su cuenta de Persona Autorizada en los
            próximos 5 días.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
export default adultPageFourSuccess
